document.addEventListener('DOMContentLoaded', function() {
  // ---- 1. Details FAQ accordion (event delegation for dynamically injected items) ----
  document.addEventListener('click', function(e) {
    var top = e.target.closest('.details_faq_item_top');
    if (!top) return;
    var parent = top.closest('.details_faq_item');
    if (!parent) return;
    var content = parent.querySelector('.details_faq_item_content');
    if (!content) return;
    var isActive = parent.classList.contains('active');
    if (isActive) {
      parent.classList.remove('active');
      content.style.display = 'none';
    } else {
      parent.classList.add('active');
      content.style.display = 'block';
    }
  });

  function closeFabricGuideDrawer(drawer) {
    drawer.classList.remove('active');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.setAttribute('data-fluorescent-overlay-open', 'false');
  }

  function activateFabricGuidePanel(drawer, index) {
    if (!drawer) return;
    var indexStr = String(index);

    drawer.querySelectorAll('[data-fabric-guide-thumb]').forEach(function(thumb) {
      var isActive = thumb.getAttribute('data-index') === indexStr;
      thumb.classList.toggle('is-active', isActive);
      thumb.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    drawer.querySelectorAll('[data-fabric-guide-panel]').forEach(function(panel) {
      var isActive = panel.getAttribute('data-index') === indexStr;
      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;
    });
  }

  // Fabric Guide drawer (Stiletto store-availability-drawer pattern)
  document.addEventListener('click', function(e) {
    var drawer = document.querySelector('[data-fabric-guide-drawer]');
    if (!drawer) return;

    if (e.target.closest('[data-fabric-guide-drawer-trigger]')) {
      e.preventDefault();
      activateFabricGuidePanel(drawer, drawer.getAttribute('data-fabric-guide-active-index') || '0');
      drawer.classList.add('active');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.setAttribute('data-fluorescent-overlay-open', 'true');
      return;
    }

    if (e.target.closest('[data-fabric-guide-drawer-close], [data-fabric-guide-drawer-wash]')) {
      e.preventDefault();
      closeFabricGuideDrawer(drawer);
      return;
    }

    var thumb = e.target.closest('[data-fabric-guide-thumb]');
    if (thumb && thumb.closest('[data-fabric-guide-drawer]')) {
      activateFabricGuidePanel(drawer, thumb.getAttribute('data-index'));
      return;
    }

    var lightboxTrigger = e.target.closest('[data-fabric-guide-lightbox]');
    if (!lightboxTrigger) return;
    if (typeof productData !== 'undefined' && !productData.enableLightbox) return;
    if (typeof openProductLightbox !== 'function') return;

    e.preventDefault();

    var lightboxDrawer = lightboxTrigger.closest('[data-fabric-guide-drawer]');
    if (!lightboxDrawer) return;

    var triggers = lightboxDrawer.querySelectorAll('[data-fabric-guide-lightbox]');
    var dataSource = [];
    var startIndex = parseInt(lightboxTrigger.getAttribute('data-index'), 10) || 0;

    triggers.forEach(function(t) {
      var img = t.querySelector('img');
      var src = t.getAttribute('data-pswp-src') || (img && (img.currentSrc || img.src)) || '';
      var w = (img && img.naturalWidth) || parseInt(t.getAttribute('data-pswp-width'), 10) || 1600;
      var h = (img && img.naturalHeight) || parseInt(t.getAttribute('data-pswp-height'), 10) || 1600;
      dataSource.push({ src: src, width: w || 1600, height: h || 1600, type: 'image' });
    });

    if (dataSource.length) openProductLightbox(dataSource, startIndex);
  });

  document.addEventListener('keydown', function(e) {
    if (e.key !== 'Escape') return;
    var drawer = document.querySelector('[data-fabric-guide-drawer]');
    if (!drawer || !drawer.classList.contains('active')) return;
    closeFabricGuideDrawer(drawer);
  });

  // Configurations "More" button
  document.querySelectorAll('.configurations-section-box').forEach(box => {
    const swatches = box.querySelectorAll('.gpo-ov-wrapper .gpo-swatches');
    if (swatches.length > 8) {
      const moreBtn = box.querySelector('.configurations-more');
      if (moreBtn) moreBtn.style.display = 'flex';
    }
  });

});
